<template>
  <div class="home">
  
    <Reproductor msg="Objetos del aula" audio2="../mp3/PrimariaA/06PA.mp3" cover="../img/1.jpg" name="Primaria A - Lección #6"/>
    <Buttons/>
  </div>
</template>

<script>
// @ is an alias to /src

import Buttons from '@/components/Buttons.vue'
import Reproductor from '@/components/Reproductor.vue'
export default {
  name: 'LeccionA6',

  components: {
    Reproductor,
    Buttons,
    
  }
}
</script>
